const outputTables = [
    {
        key: "table101",
        name: "Input - 101 (前繰)5(1)：利益積立金額.csv",
        "data-at_id": "data_table101"
    },
    {
        key: "table102",
        name: "Input - 102 (前繰)5(1)：資本金等の額.csv",
        "data-at_id": "data_table102"
    },
    {
        key: "table104",
        name: "Input_Output - 104 1･3：法人税額の計算基礎.csv",
        "data-at_id": "data_table104"
    },
    {
        key: "table105",
        name: "Input_Output - 105 4･5(1)：当期利益・納税充当金・通算税効果額等.csv",
        "data-at_id": "data_table105"
    },
    {
        key: "table106",
        name: "Input_Output - 106 4･5(1)：通算税効果額の決済額等.csv",
        "data-at_id": "data_table106"
    },
    {
        key: "table108",
        name: "Input_Output - 108 4･5(1)：連結法人税個別帰属額の決済額等.csv",
        "data-at_id": "data_table108"
    },
    {
        key: "table110",
        name: "Output - 110 4･5(1)：剰余金処分.csv",
        "data-at_id": "data_table110"
    },
    {
        key: "table111",
        name: "Output - 111 5(1)：資本金等の額.csv",
        "data-at_id": "data_table111"
    },
    {
        key: "table113",
        name: "Input_Output - 113 5(2)：法人住民税・事業税等.csv",
        "data-at_id": "data_table113"
    },
    {
        key: "table114",
        name: "Input_Output - 114 5(2)：その他の税金.csv",
        "data-at_id": "data_table114"
    },
    {
        key: "table201",
        name: "Input_Output - 201 6の2(1)：預貯金・公社債の利子.csv",
        "data-at_id": "data_table201"
    },
    {
        key: "table202",
        name: "Input_Output - 202 8の2：関連法人株式等に係る負債利子控除の計算基礎(総資産).csv",
        "data-at_id": "data_table202"
    }
];

export { outputTables };
